export default __webpack_public_path__ + "static/media/dados_consequencias.baac1d1d.png";